export const state = () => ({
  momentOfConsumeList: [],
  menuSectionTypesList: [],
  templateList: [],
  menuFontList: [],
  printMenuSectionList: [],
  menuPrintConfiguration: null,
  menuGridConfiguration: null,
});
